import request from '@/utils/request'


// 查询管线信息列表
export function listPipeline (query) {
  return request({
    url: '/saifuneng/saifuneng-pipeline/list',
    method: 'get',
    params: query
  })
}

// 查询管线信息分页
export function pagePipeline (query) {
  return request({
    url: '/saifuneng/saifuneng-pipeline/page',
    method: 'get',
    params: query
  })
}

// 查询管线信息详细
export function getPipeline (data) {
  return request({
    url: '/saifuneng/saifuneng-pipeline/detail',
    method: 'get',
    params: data
  })
}

// 新增管线信息
export function addPipeline (data) {
  return request({
    url: '/saifuneng/saifuneng-pipeline/add',
    method: 'post',
    data: data
  })
}

// 修改管线信息
export function updatePipeline (data) {
  return request({
    url: '/saifuneng/saifuneng-pipeline/edit',
    method: 'post',
    data: data
  })
}

// 删除管线信息
export function delPipeline (data) {
  return request({
    url: '/saifuneng/saifuneng-pipeline/delete',
    method: 'post',
    data: data
  })
}

// 查询客户信息列表
export function userPage (query) {
  return request({
    url: '/system/user/page',
    method: 'get',
    params: query
  })
}
